module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"hide-menu-label":"Masquer le menu","show-menu-label":"Afficher le menu","close":"Fermer","zoomIn":"Zoomer","zoomOut":"Dézommer","centerToExtent":"Rencentrer sur la zone d\u0027intérêt"},"de":{}}')
  delete Component.options._Ctor
}
